import * as t from 'io-ts';
import { authorizedTo, id, meta, users } from '../..';

const data = t.type({
  title: t.union([t.string, t.null]),
  users,
});

export const filterCodec = t.type({
  id,
  data: t.type({
    id: t.union([t.number, t.undefined, t.null]),
    title: t.union([t.string, t.null]),
  }),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data,
  authorizedTo,
});

export const formCodec = t.type({
  title: t.string,
  users: t.array(t.number),
});
